import * as React from "react";
import {Business, CurrentUser, UserCard, UserType} from "../../../types/Types";
import {Col, Form, InputGroup, Row} from "react-bootstrap";
import {useState} from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faDeleteLeft, faStar} from "@fortawesome/free-solid-svg-icons";
import {httpsCallable} from "@firebase/functions";
import {functions} from "../../../firebase/FirebaseProvider";
import NumberFlow from '@number-flow/react'
import continuous from '@number-flow/react'

interface Props {
  currentUser: CurrentUser,
  business: Business | undefined,
  card: UserCard,
}

function CardAddPoints(props: Props) {
  const [purchaseAmount, setPurchaseAmount] = useState<string>("");
  const [pointsToAdd, setPointsToAdd] = useState<string>("");
  const [transacting, setTransacting] = useState<boolean>(false);

  const [calcFromPurchase, setCalcFromPurchase] = useState<boolean>(true);

  const handlePurchaseAmount = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    if (/^\d*\.?\d*$/.test(value)) {
      setPointsToAdd("");
      setPurchaseAmount(value);
    }
  };

  const handlePointsToAdd = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    if (/^\d*\.?\d*$/.test(value)) {
      setPurchaseAmount("");
      setPointsToAdd(value);
    }
  };

  const incrementPoints = (points: number) => {
    setPurchaseAmount("");
    setPointsToAdd((+pointsToAdd + points).toString(10));
  };

  const pointsCalculation = (): string => {
    if (purchaseAmount && +purchaseAmount > 0) {
      return (+purchaseAmount * props.business!.configuration!.pointsPerEuro).toFixed(0)
    } else if (pointsToAdd && +pointsToAdd > 0) {
      return pointsToAdd
    }
    return "0";
  };

  const applyPoints = async () => {
    if (props.business == undefined) {
      return
    }
    if (+pointsCalculation() === 0) {
      return
    }
    setTransacting(true);
    const transactPoints = httpsCallable(functions, 'transactPoints');
    await transactPoints({
      business: props.business.id,
      card: props.card.id,
      points: +pointsCalculation(),
    }).then(() => {
      setPurchaseAmount("");
      setPointsToAdd("");
      setTransacting(false);
    });
  };

  return (
      <>
        {props.currentUser.userType == UserType.LOCATION_MANAGER && <div className={"list-bg mt-3"}>
            <div className={"list-title"}>
                <b>Add Points</b>
                <div className={"float-right"}>Balance: <span className={"font-weight-600"}><NumberFlow plugins={[continuous]} value={props.card.points}/></span></div>
            </div>

            <div className={"row mt-2 mb-2"}>
                <div className={"col"}>
                    <div className={`primary-button bg-blue ${calcFromPurchase ? 'selected' : ''}`} onClick={() => setCalcFromPurchase(true)}>
                        <b>Calculate</b>
                    </div>
                </div>

                <div className={"col"}>
                    <div className={`primary-button bg-blue ${calcFromPurchase ? '' : 'selected'}`} onClick={() => setCalcFromPurchase(false)}>
                        <b>Manual</b>
                    </div>
                </div>
            </div>

          {calcFromPurchase && <div className={"basic-box mb-2"}>
              <Form>
                  <Form.Group controlId="formEuroAmount">
                      <InputGroup>
                          <InputGroup.Text>€</InputGroup.Text>
                          <Form.Control
                              type="number"
                              step="0.01"
                              placeholder="0.00"
                              value={purchaseAmount}
                              onChange={handlePurchaseAmount}
                              aria-label="purchaseAmount"
                          />
                      </InputGroup>
                      <Form.Text className="text-muted">
                        {props.business &&
                        <span className={"font-white"}>Enter the purchase amount, rate is  <b>{props.business.configuration.pointsPerEuro}</b> point per <b>€</b></span>}
                      </Form.Text>
                  </Form.Group>
              </Form>
          </div>}

          {!calcFromPurchase && <div>
              <div className={"basic-box mb-2"}>
                  <Form>
                      <Form.Group controlId="addPoints">
                          <InputGroup>
                              <InputGroup.Text><FontAwesomeIcon icon={faStar}/></InputGroup.Text>
                              <Form.Control
                                  type="number"
                                  step="0"
                                  placeholder="0"
                                  value={pointsToAdd}
                                  onChange={handlePointsToAdd}
                                  aria-label="pointsToAdd"
                              />
                          </InputGroup>
                          <Form.Text className="text-muted">
                              <span className={"font-white"}>Enter the number of points to add</span>
                          </Form.Text>
                      </Form.Group>
                  </Form>
              </div>

              <div className={"mb-2 basic-box"}>
                  <Row>
                      <Col>
                          <div className={"primary-button bg-blue"} onClick={() => incrementPoints(50)}>50</div>
                      </Col>
                      <Col>
                          <div className={"primary-button bg-blue"} onClick={() => incrementPoints(20)}>20</div>
                      </Col>
                      <Col>
                          <div className={"primary-button bg-blue"} onClick={() => incrementPoints(10)}>10</div>
                      </Col>
                      <Col>
                          <div className={"primary-button bg-blue"} onClick={() => incrementPoints(5)}>5</div>
                      </Col>
                      <Col>
                          <div className={"primary-button bg-blue"} onClick={() => incrementPoints(1)}>1</div>
                      </Col>
                      <Col>
                          <div className={"primary-button red"} onClick={() => setPointsToAdd("")}><FontAwesomeIcon className={"font-md"} icon={faDeleteLeft} /></div>
                      </Col>
                  </Row>
              </div>
          </div>}

            <div className={"mb-0"}>
              {!transacting && <div className={"primary-button bg-blue"} onClick={() => applyPoints()}>
                  <span>Add <b><NumberFlow plugins={[continuous]} value={pointsCalculation()}/></b> point{+pointsCalculation() === 1 ? '' : 's'}</span>
              </div>}
              {transacting && <div className={"primary-button bg-blue"}>
                  <span>Transacting...</span>
              </div>}
            </div>
        </div>}
      </>
  )
}

export default CardAddPoints;